import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Reusable subpage hero: back-to-home affordance + pill eyebrow + display headline + intro.
const PageHero = ({ eyebrow, title, accent, intro, testId }) => (
    <section className="relative pt-28 lg:pt-32 pb-10 lg:pb-14 overflow-hidden" data-testid={testId}>
        <div className="absolute inset-0 hero-grid mask-fade-b pointer-events-none" />
        <div className="absolute inset-0 grain pointer-events-none" />

        <div className="relative max-w-7xl mx-auto px-5 lg:px-10">
            <Link
                to="/"
                className="inline-flex items-center gap-2 text-ivory/60 hover:text-gold transition-colors text-sm font-mono uppercase tracking-widest"
                data-testid="page-back-home"
            >
                <ArrowLeft className="w-4 h-4" /> Home
            </Link>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="mt-8"
            >
                <div className="pill"><span className="accent-dot" />{eyebrow}</div>
                <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl text-ivory tracking-tight leading-[1.04]">
                    {title}{" "}
                    {accent && <span className="italic text-gold-shimmer">{accent}</span>}
                </h1>
                {intro && (
                    <p className="mt-6 text-ivory/70 text-base lg:text-lg max-w-2xl leading-relaxed">
                        {intro}
                    </p>
                )}
            </motion.div>
        </div>
    </section>
);

export default PageHero;
